<template>
<div>
    <p-button v-if="submit && nativeSubmit" :disabled="disableSubmit" nativeType="submit" type="success" outline size="sm"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>
    <p-button v-if="submit && !nativeSubmit" :disabled="disableSubmit" @click="onSubmit" type="success" outline size="sm"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>
    <p-button v-if="reset" :disabled="disableReset" @click="onReset" type="default" outline size="sm"><i class="fas fa-sync"></i>{{ $t('button.reset') }}</p-button> 
    <RemoveButton v-if="remove" :itemid="itemid" :modalid="modalid" :confirmmsg="deleteConfirmation" :disabled="disableRemove" @remove="onRemove"></RemoveButton>
</div>
</template>


<script>
import RemoveButton from '@/components/Misc/RemoveButton'

export default {
  name: 'FormButtons', 
  components: {
    RemoveButton
  },
  props: {
    itemid: {type: String},
    modalid: {type: String},
    deleteConfirmation: { type: String },
    submit: { type: Boolean, default: true },
    reset: { type: Boolean, default: true },
    remove: { type: Boolean, default: true },
    disableSubmit: { type: Boolean, default: false },
    disableReset: { type: Boolean, default: false },
    disableRemove: { type: Boolean, default: false },
    nativeSubmit: { default: false }
  },
  data() {
      return {
        removeDisabledByMethod: false
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit');
    },
    onReset(){
      this.$emit('reset');
    },
    onRemove() {
      this.$emit('remove');
    }
   }
}
</script>
